export const OVERVIEW_PATH = '/rfqs';
export const OVERVIEW_FINISHED_PATH = '/rfqs/finished';
export const OVERVIEW_TESTING_PATH = '/rfqs/testing';

export const CHANNEL_PATH = '/rfqs/channels/:channelId';
export const CHANNEL_FINISHED_PATH = '/rfqs/channels/:channelId/finished';
export const CHANNEL_TESTING_PATH = '/rfqs/channels/:channelId/testing';
export const CHANNEL_CONFIG_PATH = '/rfqs/channels/:channelId/config/:tab?/:configId?';
export const CHANNEL_MASTERDATA_PATH = '/rfqs/channels/:channelId/masterdata';

export const ASSISTANCE_PATH = '/rfqs/:recordId';
export const ASSISTANCE_TAB_PATH = '/rfqs/:recordId/:tab';
